export default __webpack_public_path__ + "static/media/023-money-bag.d4587f91.png";